import React from 'react';
import ResourceLookupPage from 'pages/wholeme/molecules/resourceLookupPage/ResourceLookupPage';
import MainImage from 'pages/wholeme/molecules/mainImage/MainImage';
import appStrings from '../../../../../common/app_strings';
import { useAppState } from '../../../../../providers/app-state/app-state-provider';

const {
  wholeMe: {
    wholeMeEducationIntake: {
      title,
      subtitle,
    },
  },
} = appStrings;

const profileEducationIntakeSchoolsPage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
}) => {
  const { platform } = useAppState();

  return (
    <ResourceLookupPage
      paginationMeta={paginationMeta}
      nextOnClick={nextOnClick}
      prevOnClick={prevOnClick}
      wholeMeClient={wholeMeClient}
      categoryId="education"
      questionId="schools"
      title={title}
      subtitle={subtitle}
      dataFetcher={async () => (await wholeMeClient.fetchSchoolsState())?.schools}
      dataSaver={wholeMeClient.saveSchoolsState}
      resourceType="schools"
      resultAttributeId="school"
      backgroundOverlay="./assets/overlays/two-circle-background-overlay.svg"
      selectionRequired
    >
      <MainImage
        imageSrc="./assets/profile/education/whats-your-school-icon.svg"
        imageAlt="blue circle icon"
        imageStylesOverride={{
          paddingLeft: '2rem',
          width: platform?.isNativePlatform ? 'calc(100% - 80px' : 'calc(45% - 80px)',
        }}
      />
    </ResourceLookupPage>
  );
};

export default profileEducationIntakeSchoolsPage;
